/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li1_PostInputs */

const tr_iade_iptal_s5_li1_post = /** @type {(inputs: Iade_Iptal_S5_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` adresine iletilir. Süre, ödemenin Sağlayıcı tarafından alındığı andan itibaren işlemeye başlar.`)
};

const en_iade_iptal_s5_li1_post = /** @type {(inputs: Iade_Iptal_S5_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` stating the payment date and the order or invoice details. The period runs from the moment the payment is received by the Provider.`)
};

const de_iade_iptal_s5_li1_post = /** @type {(inputs: Iade_Iptal_S5_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` zu richten. Die Frist läuft ab dem Zeitpunkt, zu dem die Zahlung beim Anbieter eingegangen ist.`)
};

const ru_iade_iptal_s5_li1_post = /** @type {(inputs: Iade_Iptal_S5_Li1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` с указанием даты платежа и данных заказа или счёта. Срок исчисляется с момента получения платежа Поставщиком.`)
};

/**
* | output |
* | --- |
* | "stating the payment date and the order or invoice details. The period runs from the moment the payment is received by the Provider." |
*
* @param {Iade_Iptal_S5_Li1_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li1_post = /** @type {((inputs?: Iade_Iptal_S5_Li1_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li1_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li1_post(inputs)
	if (locale === "de") return de_iade_iptal_s5_li1_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li1_post(inputs)
	return tr_iade_iptal_s5_li1_post(inputs)
});